module.exports = __webpack_public_path__ + "img/payment-button.2d025a52.svg";